import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'
import ButtonText from '@segment/matcha/components/ButtonText'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import CustomerImage from './CustomerImage'

const copy = {
  overline: `Segment for Marketing Teams`,
  heading: `Complete view of the customer`,
  description: `Unify your customer’s touch points across all platforms and channels.`,
}

const link = {
  text: `Explore Segment for Marketers`,
  url: `/product/twilio-engage/`,
}

const Customer: FC<PropsWithChildren<unknown>> = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <StyledSectionBase variant="2Col" copyVariant="narrow">
        <SectionCopy>
          <CopyTextBase>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading variant="h2" tag="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pLarge">{copy.description}</CopyText.Description>
            <LinkWrapper size="medium" tag="a" href={getAbsoluteUrl(link.url, pageConfig)} iconEnd={ChevronRightIcon}>
              {link.text}
            </LinkWrapper>
          </CopyTextBase>
        </SectionCopy>

        <Section.Contents>
          <CustomerImage />
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  display: grid;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    padding-top: 20px;
  }
`

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const LinkWrapper = styled(ButtonText)`
  padding-top: 0;
`

const SectionCopy = styled(Section.Copy)`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 392px;
    justify-self: end;
    align-self: center;
  }
`

export default Customer
